import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Blog.css";
import Banner from "../../images/banner.jpg";
import NavBar from "../Layout/NavBar";
import Footer from "../Footer/Footer";
import blogCategories from "../../data/blogCategories";
import { loadBlogAnalytics } from "../../utils/loadBlogAnalytics";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");

  // Load blogs with analytics merged
  useEffect(() => {
    async function load() {
      const merged = await loadBlogAnalytics(30);

      // Sort newest first (because analytics merge loses Firestore ordering)
      merged.sort((a, b) => {
        return (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0);
      });

      setPosts(merged);
    }
    load();
  }, []);

  // Filter using tags instead of category
  const filteredPosts = posts.filter((post) => {
    if (activeCategory === "all") return true;
    return post.tags?.some(
      (tag) => tag.toLowerCase() === activeCategory.toLowerCase()
    );
  });

  function timeAgo(ts) {
    const date = ts.toDate();
    const diff = (Date.now() - date.getTime()) / 1000; // seconds

    const minutes = diff / 60;
    const hours = diff / 3600;
    const days = diff / 86400;
    const months = diff / (86400 * 30);   // approx
    const years = diff / (86400 * 365);   // approx

    if (diff < 60) return "Just now";
    if (minutes < 60) return `${Math.floor(minutes)}m ago`;
    if (hours < 24) return `${Math.floor(hours)}h ago`;
    if (days < 30) return `${Math.floor(days)}d ago`;
    if (months < 2) return `${Math.floor(months)}mo ago`;
    if (months < 12) return `${Math.floor(months)}mos ago`;
    return `${Math.floor(years)}y ago`;
  }

  return (
    <div className="blog-list">
      <div className="shop-banner">
        <img src={Banner} alt="Shop Banner" />
      </div>

      <NavBar />

      <div className="category-header">
        <h1 className="category-title">Stories</h1>
        <p className="category-headline">Stories to fuel the imagination</p>
      </div>

      {/* Category Filter */}
      <div className="blog-filter-bar">
        <select
          value={activeCategory}
          onChange={(e) => setActiveCategory(e.target.value)}
          className="blog-category-select"
        >
          <option value="all">All Categories</option>
          {blogCategories.map((cat) => (
            <option key={cat.slug} value={cat.slug}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      {/* Blog Grid */}
      <div className="blog-grid">
        {filteredPosts.map((post) => (
          <Link key={post.id} to={`/blog/${post.id}`} className="blog-card">

            {/* YouTube embed thumbnail */}
            {post.embedUrl && post.embedThumbnail && (
              <img
                src={post.embedThumbnail}
                className="blog-thumb"
                alt={post.title}
              />
            )}

            {/* Uploaded video */}
            {!post.embedUrl && post.video && (
              <video
                src={post.video}
                poster={post.headerImage}
                className="blog-thumb"
                muted
                preload="metadata"
              />
            )}

            {/* Header image fallback */}
            {!post.embedUrl && !post.video && post.headerImage && (
              <img src={post.headerImage} className="blog-thumb" alt={post.title} />
            )}

            <h2>{post.title}</h2>

            <div className="blog-meta-row">
              <div className="blog-tags">
                {post.tags?.slice(0, 3).map((tag, i) => (
                  <span key={i} className="blog-tag">{tag}</span>
                ))}
              </div>

              <div className="blog-likes">
                {post.likes || 0}
              </div>
            </div>

            <div className="summary">
              <p>
                {post.summary}
              </p>
            </div>

            <div className="product-footer">
              <span className="product-date">{timeAgo(post.createdAt)}</span>
            </div>

          </Link>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Blog;
